<template>
  <div>
    <AiLayout
      ref="AiLayout"
      :aiType="aiType"
      :status="status"
      :inputMode="inputMode"
      :outputMode="outputMode"
      :haveSuccess="haveSuccess"
      :mode="mode"
      @addResourceData="addResourceData"
      @downloadImg="downloadImgAll"
      @startIdentify="startIdentify"
      @startIdentifyCustom="startIdentifyCustom"
      @useCustomMulti="useCustomMulti"
      @useCustom="useCustom"
      @insertMethod="insertMethod"
      @emitAccountInfo="emitAccountInfo"
    >
      <template v-slot:identify-content>
        <div>
          <div class="content-uploader" v-show="inputMode.includes('file')" :style="{height: resourceData.length > 0 ? '150px' : styles?.tableHeight ? styles.tableHeight + 'px' : '550px'}" @dragover.prevent @drop="handleDrop($event)" @click="openFile">
            <i class="iconfont upload-icon">&#xe7ed;</i>
            <span class="upload-title">拖拽或点击上传本地图片</span>
            <span class="upload-subTitle">支持PNG、JPG、JPEG、GIF图片，最大支持10.00MB图片</span>
            <div class="upload-tip" v-show="resourceData.length === 0">
              <div class="tip-card" v-for="(item, index) in tipList" :key="index">
                <div class="tip-title">{{ item.title }}</div>
                <div class="tip-content">{{ item.content }}</div>
              </div>
            </div>
          </div>
          <div class="content-list" v-show="resourceData.length > 0">
            <el-alert
               v-if="inputMode.includes('multiEditor')" 
              title="处理重复图片仅消耗一次服务使用次数"
              type="info"
              style="margin-bottom: 10px;"
            />
            <el-table
              ref="resourceDataTable"
              :data="resourceData"
              :height=" styles?.tableHeight ? styles.tableHeight - 150 : '400'"
              :header-cell-style="{ background: '#eee' }"
              :cell-style="{ 'border-bottom': '1px solid #ddd' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                v-if="inputMode.includes('multiEditor')" 
                type="selection"
                width="55"/>
              <el-table-column label="" prop="thumbnail" width="60" >
                <template slot-scope="scope">
                  <el-image
                    fit="contain"
                    style="width: 40px; height: 40px; border-radius: 4px"
                    :src="scope.row.local_url || `${scope.row.thumbnail || scope.row.url}?w=40&h=40&t=1&context=thumb`"
                    :preview-src-list="[scope.row.url]"
                  >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column label="图片名称" width="160">
                <template slot-scope="scope">
                  <div style="display:flex;">
                    <span style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ splitFileTitle(scope.row.file_name)[0] }}</span>
                    <span style="overflow: visible;flex-basis: 50px;flex-shrink: 0;">{{ splitFileTitle(scope.row.file_name)[1] }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="尺寸">
                <template slot-scope="scope">
                  {{ scope.row.width }} * {{ scope.row.height }}
                </template>
              </el-table-column>
              <el-table-column label="原图">
                <template slot-scope="scope">
                  {{ scope.row.length ? formatFileSize(scope.row.length) : '' }}
                </template>
              </el-table-column>
              <el-table-column label="压缩后" prop="slim_length">
                <template slot-scope="scope">
                  {{ scope.row.slim_length ? formatFileSize(scope.row.slim_length) : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="slim_rate">
                <template slot="header">
                  <span>压缩比例</span>
                  <el-popover
                    popper-class="base-popover"
                    placement="top"
                    title=""
                    width="200"
                    trigger="hover"
                    content="计算公式：取整（(1-压缩后文件大小/原始文件大小)*-1）*100%">
  
                    <i slot="reference" style="margin-left: 3px;" class="el-icon-question" />
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="处理状态" prop="slim_rate">
                <template slot-scope="scope">
                  <span :class="`${scope.row.slim_status}`" class="dot" />
                  {{ getStatusText(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60" >
                <template slot-scope="scope" >
                  <span
                    v-if="scope.row.slim_ref_id && (inputMode.includes('multiEditor') || inputMode.includes('singleEditor'))"
                    class="table-span"
                    @click="useCustom(scope.row)"
                  >
                    替换
                  </span>
                  <span
                    v-if="scope.row.slim_url && !(inputMode.includes('multiEditor') || inputMode.includes('singleEditor'))"
                    class="table-span"
                    @click="downloadImg(scope.row)"
                  >
                    下载
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="content-empty" v-show="resourceData.length === 0 && inputMode.includes('multiEditor')">
            <span>无图片资源</span>
          </div>
        </div>
      </template>
    </AiLayout>
  </div>
</template>

<script>
const statusObj = {
  wait: '待处理',
  ing: '处理中',
  success: '处理完成',
  repeat: '重复图片',
  error: '服务使用超限',
  replaced: '替换完成', //只在批量替换中出现的状态
}
import AiLayout from '@/layout/AiLayout.vue'
import { formatFileSize, splitFileTitle } from '@/utils/common'
import axios from 'axios'
export default {
  name: 'ImageSlim',
  components: {
    AiLayout
  },
  props: {
    inputMode: {
      type: Array,
      default: () => ['file', 'resource'],
    },
    outputMode: {
      type: Array,
      default: () => ['file'],
    },
    inputList: {
      type: Array,
      default: () => [],
    },
    inputData: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    }
  },
  mounted() {
    if (this.inputMode.includes('multiEditor')) {
      this.resourceDataMultiChange(this.inputList)
    } else if (this.inputMode.includes('singleEditor')) {
      this.resourceDataMultiChange([this.inputData])
    }
  },
  data() {
    return {
      aiType: 'image_slim',
      status: 'wait',
      statusObj: statusObj,
      resourceData: [],
      resourceRefIdList: [],
      selectedRows: [],
      haveSuccess: false,
      tipList: [
        {
          title: '第一步：上传文件',
          content: '支持上传本地图片、素材库图片',
        },
        {
          title: '第二步：开始处理',
          content: '点击“开始处理”按钮，图片进行处理',
        },
        {
          title: '第三步：使用素材',
          content: '可将图片进行下载或直接使用素材库中的图片',
        },
      ]
    }
  },
  provide() {
    return {
      resourceData: this.resourceData,
    }
  },
  methods: {
    formatFileSize,
    splitFileTitle,
    openResource() {
      this.$refs.AiLayout.showResource()
    },
    handleDrop(event) {
      this.$refs.AiLayout.handleDrop(event)
    },
    openFile() {
      this.$refs.AiLayout.openFile(true)
    },
    addResourceData(resource) {
      const _list = this.resourceData
      function addResourceCore(_resource) {
        if (!_resource.slim_status) {
          _resource.slim_status = 'wait'
        }
        if (!_list.find(item => item.ref_id === _resource.ref_id) || !_resource.ref_id) {
          _list.unshift(_resource)
        }
      }
      if (Array.isArray(resource)) {
        resource.forEach(element => {
          addResourceCore(element)    
        })
      } else {
        addResourceCore(resource)
      }
      this.resourceData = [..._list]
      this.$forceUpdate()
    },
    resourceDataMultiChange(data) {
      // multi
      const _refIdList = []
      data.forEach((element, index) => {
        element.index = index
        if (!element.slim_status) {
          if (_refIdList.includes(element.ref_id)) {
            element.slim_status = 'repeat'
          } else {
            _refIdList.push(element.ref_id)
            element.slim_status = 'wait'
          }
        }
      })
      this.resourceRefIdList = [..._refIdList]
      this.resourceData = [...data]
      // 选中所有
      this.$forceUpdate()
      setTimeout(()=>{
        this.toggleSelection(this.resourceData)
      },200)
    },
    toggleSelection(rows) {
      rows.forEach(row => {
        this.$refs.resourceDataTable.toggleRowSelection(row, true);
      })
    },
    getStatusText(row) {
      switch(row.slim_status) {
        case 'error':
          return row.display_error ? row.display_error.replace(/[a-zA-Z:. ()]/g, '') : '压缩失败'
        default:
          return this.statusObj[row.slim_status]
      }
    },
    downloadImgAll() {
      const _refIds = []
      this.resourceData.forEach(ele => {
        if (ele.slim_ref_id) {
          _refIds.push(ele.slim_ref_id)
        }
      })
      if (_refIds.length > 0) {
        window.open(`/index/files/download?ref_ids=${JSON.stringify(_refIds)}`)
      } else {
        this.$message({
          type: 'error',
          message: '没有可导出的图片',
        })
      }
    },
    downloadImg(row) {
      const tag = document.createElement('a')
      tag.setAttribute('download', row.file_name)
      tag.href = row.slim_url
      tag.click()
    },
    startIdentify(customData, callback) {
      const postList = []
      const waitList = customData ? customData.filter(item => (item.slim_status !== 'success' && item.slim_status !== 'replaced')) : this.resourceData.filter(item => item.slim_status === 'wait')
      if (waitList.length === 0) {
        this.$message({
          type: 'info',
          message: '已全部处理完成，无需继续处理',
        })
        return
      }

      this.status = 'ing'
      waitList.forEach((item) => {
        item.slim_status = 'ing'
        if (item.identifyType && item.identifyType === 'custom') {
          const formData = new FormData()
          formData.append('file', item.file)
          if (this.$refs.AiLayout.saveFolderId) {
            formData.append('folder_id',this.$refs.AiLayout.saveFolderId)
          }
          formData.append('width', item.width)
          formData.append('height', item.height)
          postList.push(
            axios.post(`/index/image_slim/identify_local_file`, formData)
          )
        } else {
          postList.push(
            axios.post(`/index/image_slim/identify`, {
              ref_id: item.ref_id,
              folder_id: this.$refs.AiLayout.saveFolderId,
            })
          )
        }
      })

      axios.all(postList).then(
        axios.spread((...resArr) => {
          let isIncludeErrorResponse = false;
          resArr.forEach((res, index) => {
            if (res.data) {
              const _data = res.data.data
              const _find = waitList[index]
              if (res.data.status === 0) {
                _find.slim_ref_id = _data.file_id
                _find.slim_rate = _data.slim_rate
                _find.slim_length = _data.length
                _find.slim_url = _data.url
                _find.slim_width = _data.width
                _find.slim_height = _data.height
                _find.slim_status = 'success'
                this.$emit('updateHistory')
                if (this.inputMode.includes('multiEditor') && _find.ref_id) {
                  // 将处理数据都铺上去
                  this.resourceData.forEach(element => {
                    if (element.ref_id === _find.ref_id
                      && (element.slim_status === 'repeat' || element.slim_status === 'wait')
                    ) {
                      element.slim_status = 'success'
                      element.slim_ref_id = _data.file_id
                      element.slim_rate = _data.slim_rate
                      element.slim_length = _data.length
                      element.slim_width = _data.width
                      element.slim_height = _data.height
                      element.slim_url = _data.url
                    }
                  })
                }
              } else {
                isIncludeErrorResponse = true;
                _find.slim_status = 'error'
                _find.display_error = res.data.error
                this.$message({
                  type: 'error',
                  message: res.data.error,
                })
              }
            }
          })

          this.status = 'wait'
          this.haveSuccess = true

          if (!isIncludeErrorResponse) {
            this.$message({
              type: 'success',
              message: '图片智能压缩处理完成',
            })
          }
          callback && callback()
        })
      )
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },
    startIdentifyCustom() {
      const _refIdList = []
      const _identifyData = []
      this.selectedRows.forEach(element => {
        if (!_refIdList.includes(element.ref_id)) {
          _identifyData.push(element)
          _refIdList.push(element.ref_id)
        }
      })
      if (_identifyData.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择处理的图片',
        })
        return
      }
      this.startIdentify(_identifyData)
    },
    useCustom(data) {
      // 兼容单替，默认拿取第一行的结果
      if(!data) {
        data = this.resourceData[0]
      }
      this.$emit('customMethod', data)
    },
    insertMethod() {
      this.$emit('insertMethod', this.resourceData)
    },
    useCustomMulti() {
      const _list = this.selectedRows.filter(item => item.slim_ref_id)
      if (_list.length === 0) {
        if (this.selectedRows.find(element => (element.slim_status === 'wait' || element.slim_status === 'repeat'))) {
          this.$message({
            type: 'error',
            message: '有待处理的图片，请点击【开始处理】',
          })
        } else {
          this.$message({
            type: 'error',
            message: '请选择需要替换的图片',
          })
        }
        this.$refs.AiLayout.stopBtnLoading()
        return
      }
      this.$emit('customMethod', _list)
    },
    markReplaced(list) {
      list.forEach(element => {
        const _findRow = this.selectedRows.find(ele => (element.ref_id === ele.ref_id))
        _findRow.slim_status = 'replaced'
      })
      this.$refs.AiLayout.stopBtnLoading()
    },
    emitAccountInfo(info) {
      this.$emit('emitAccountInfo', info)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .image-slot {
  text-align: center;
  margin-top: 10px;
  i {
    font-size: 20px;
  }
}
.content-uploader {
  cursor: pointer;
  flex: 1;
  background-color: #F5F5F5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .upload-icon {
    color: #CCCCCC;
    font-size: 60px;
    margin-bottom: 5px;
  }
  .upload-title {
    font-size: 20px;
    color: #333333;
    font-weight: 600;
  }
  .upload-subTitle {
    margin-top: 10px;
    font-size: 14px;
    color: #999999;
  }
  .upload-tip {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;
    .tip-card {
      margin: 0 15px;
      width: 300px;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #FFFFFF;
      border-radius: 3px;
      padding: 0 20px;
      .tip-title {
        font-size: 14px;
        color: #666666;
      }
      .tip-content {
        margin-top: 10px;
        font-size: 13px;
        color: #999999;
      }  
    }
  }
}
.content-list {
  margin-top: 10px;
  overflow-y: auto;
  .dot {
    height: 8px;
    display: inline-block;
    border-radius: 50%;
    width: 8px;
    vertical-align: middle;
    margin-right: 2px;
    &.wait {
      background-color: #FF9C25;
    }
    &.ing {
      background-color: #FF9C25;
    }
    &.success, &.replaced {
      background-color: #67c23a;
    }
    &.error {
      background-color: #F56C6C;
    }
    &.repeat {
      background-color: #CCCCCC;
    }
  }
  .table-span {
    color: #ED7700;
    cursor: pointer;
  }
}
.content-empty {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}
.h5 {
  .content-uploader {
    background-color: #2A2A2A !important;
    .upload-icon {
      color: #CCCCCC !important;
    }
    .icon {
      color: #BBBBBB !important;
    }
    .upload-title {
      color: #BBBBBB !important;
    }
    .upload-tip {
      .tip-card {
        background-color: #333333 !important;
        .tip-title {
          color: #999999 !important;
        }
        .tip-content {
          color: #999999 !important;
        }  
      }
    }
  }
}
</style>